'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002451 from "./presto.-Group-Restrictions-View$$anon$51.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$0024 from "./presto.types$-Grouping$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dDescription$0024 from "./presto.types$-Grouping-Description$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dKind$0024 from "./presto.types$-Grouping-Kind$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$50() {
  this.aTU = null;
  this.aTM = null;
  this.aTN = false;
  this.aTV = null;
  this.aTW = false;
  this.aTZ = null;
  this.aTS = null;
  this.aTT = false;
  this.aTO = null;
  this.aTP = false;
  this.aTQ = null;
  this.aTR = false;
  this.aTX = false;
  this.aTY = false;
  this.aTU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aTZ = "Grouping";
}
export { $c_Lpresto_GroupRestrictionsView$$anon$50 as $c_Lpresto_GroupRestrictionsView$$anon$50 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$50.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$50;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$50() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$50 as $h_Lpresto_GroupRestrictionsView$$anon$50 };
$h_Lpresto_GroupRestrictionsView$$anon$50.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aTU;
});
$p.L = (function() {
  if ((!this.aTN)) {
    this.aTM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aTN = true;
  }
  return this.aTM;
});
$p.O = (function() {
  if ((!this.aTW)) {
    this.aTV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aTW = true;
  }
  return this.aTV;
});
$p.E = (function() {
  return this.aTZ;
});
$p.t = (function() {
  if ((!this.aTT)) {
    this.aTS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("description", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aTT = true;
  }
  return this.aTS;
});
$p.M = (function() {
  if ((!this.aTP)) {
    this.aTO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_presto$002etypes$0024$002dGrouping$002dKind$0024.$m_Lpresto_types$GroupingKind$().p4())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dDescription$0024.$m_Lpresto_types$GroupingDescription$().p3(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aTP = true;
  }
  return this.aTO;
});
$p.Q = (function() {
  if ((!this.aTR)) {
    this.aTQ = new $j_presto$002e$002dGroup$002dRestrictions$002dView$0024$0024anon$002451.$c_Lpresto_GroupRestrictionsView$$anon$51();
    this.aTR = true;
  }
  return this.aTQ;
});
$p.w = (function() {
  if ((!this.aTY)) {
    this.aTX = false;
    this.aTY = true;
  }
  return this.aTX;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee333) => ((p) => \u03b4scrutinee333.p0(p)))($j_presto$002etypes$0024$002dGrouping$0024.$m_Lpresto_types$Grouping$())));
});
var $d_Lpresto_GroupRestrictionsView$$anon$50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$50, "presto.GroupRestrictionsView$$anon$50", ({
  IV: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$50 as $d_Lpresto_GroupRestrictionsView$$anon$50 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$50.js.map
